import { Paper } from "@mui/material";
import { BarChart, Bookmark, Category, Email, Photo, Storage, Tune } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.dashboard.ecommerce.store.categories", link: "/ecommerce/categories", icon: <Category /> },
  { text: "pages.dashboard.ecommerce.store.products", link: "/ecommerce/products", icon: <Storage /> },
  { text: "pages.dashboard.ecommerce.store.parameters", link: "/ecommerce/parameters", icon: <Tune /> },
  { text: "pages.dashboard.ecommerce.store.promos", link: "/ecommerce/promos", icon: <Email /> },
  { text: "pages.dashboard.ecommerce.store.kanban", link: "/ecommerce/kanban", icon: <Bookmark /> },
  { text: "pages.dashboard.ecommerce.store.orders", link: "/ecommerce/orders", icon: <Bookmark /> },
  { text: "pages.dashboard.ecommerce.store.statistics", link: "/ecommerce/statistics", icon: <BarChart /> },
  { text: "pages.dashboard.ecommerce.store.photos", link: "/ecommerce/photos", icon: <Photo /> },
];

export const EcommerceSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.ecommerce.store.title" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
